import type { AvatarLayerSelection } from '../types/user';

const toLayerFilename = (value: unknown): string | null => {
  const candidate = String(value ?? '').trim();
  return /\.png$/i.test(candidate) ? candidate : null;
};

export const normalizeAvatarLayerSelection = (
  value: unknown,
): AvatarLayerSelection | undefined => {
  if (!value || typeof value !== 'object') {
    return undefined;
  }

  const candidate = value as Record<string, unknown>;
  const body = toLayerFilename(candidate.body);
  const eyes = toLayerFilename(candidate.eyes);
  const hairstyle = toLayerFilename(candidate.hairstyle);
  const outfit = toLayerFilename(candidate.outfit);

  if (!body || !eyes || !hairstyle || !outfit) {
    return undefined;
  }

  return {
    body,
    eyes,
    hairstyle,
    outfit,
    accessory: toLayerFilename(candidate.accessory),
    prop: toLayerFilename(candidate.prop),
  };
};
